/**
 * @ngdoc config
 * @name httpProviderConfig
 * @description
 * Push the `apiVersionInterceptor` service into the list of `$http` interceptors, so it will
 * intercept `409`s and kick the user.
 *
 * @param {Service} $httpProvider The interface to configure the `$http` service.
 * @memberof rootModule
 */
const httpProviderConfig = ($httpProvider) => {
  'ngInject';

  $httpProvider.interceptors.push('apiVersionInterceptor');
};

export default httpProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/configs/httpProvider.config.js